import React from 'react';
import { AlertTriangle, RefreshCcw, Home } from 'lucide-react';
import { Button } from "@/components/ui/button";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-sonas-bg flex items-center justify-center p-6 text-center">
          <div className="glass-surface max-w-md w-full p-10 rounded-[32px] border border-white/5 space-y-6 shadow-2xl">
            <div className="h-16 w-16 bg-red-500/10 rounded-2xl flex items-center justify-center mx-auto">
              <AlertTriangle className="h-8 w-8 text-red-500" />
            </div>
            
            <div className="space-y-2">
              <h1 className="text-2xl font-syne font-bold text-sonas-text">Something went wrong</h1>
              <p className="text-sm text-sonas-muted leading-relaxed">
                An unexpected error occurred in this part of the workspace. Our architects have been notified.
              </p>
            </div>

            <div className="flex flex-col gap-3 pt-4">
              <Button 
                onClick={() => window.location.reload()}
                className="h-12 rounded-xl bg-sonas-accent text-sonas-bg font-bold shadow-lg shadow-sonas-accent/20"
              >
                <RefreshCcw className="h-4 w-4 mr-2" /> Reload Interface
              </Button>
              <Button 
                variant="ghost" 
                onClick={() => window.location.href = '/'}
                className="h-12 rounded-xl text-sonas-dim hover:text-sonas-text"
              >
                <Home className="h-4 w-4 mr-2" /> Back to Home
              </Button>
            </div>

            {process.env.NODE_ENV === 'development' && (
              <div className="mt-6 p-4 bg-black/40 rounded-xl text-left overflow-auto max-h-40 border border-white/5">
                <code className="text-[10px] text-red-400 font-mono whitespace-pre">
                  {this.state.error?.toString()}
                </code>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;